export default "__VITE_ASSET__DRV6yyP0__"